/* eslint-disable no-case-declarations, no-param-reassign, no-confusing-arrow */
import _ from 'lodash';
import * as types from '../action.types';

export const initialState = {};

export const initialMetadataBody = {
  key: '',
  sourceFile: '',
  source: '',
  name: '',
  type: 'User',
  format: '',
  fieldType: '',
  mapped: false,
  custom: false,
  sync: false,
  value: [],
  separator: '',
  index: 0,
};

const MetadataReducer = (state = initialState, action) => {
  let newIndex = _.size(state) > 0 ? _.size(state) : 0;

  const concatKey = name => `${action.payload.filename}.${name}`;

  const getName = (header) => {
    const check = _.some(state, column => column.name === header);
    return check ? concatKey(header) : header;
  };

  const resetName = (name, key, values = state) => {
    const check = _.some(values, column => column.key !== key && column.name === name);
    return check ? key : name;
  };

  const getMetadataBody = (header, index = newIndex) => ({
    ...initialMetadataBody,
    key: concatKey(header),
    sourceFile: action.payload.filename,
    source: header,
    name: getName(header),
    index,
  });

  switch (action.type) {
    case types.FETCH_SESSION_SUCCESS:
      if (_.size(action.payload.metadata)) {
        return { ...action.payload.metadata };
      }

      return _.reduce(action.payload.headers, (result, header) => {
        result[concatKey(header)] = getMetadataBody(header, newIndex);
        newIndex += 1;
        return result;
      }, {});

    case types.CREATE_JOIN_ITEM:
      if (_.size(action.payload.metadata)) {
        return _.reduce(action.payload.metadata, (result, metadata) => {
          result[concatKey(metadata.source)] = {
            ...metadata,
            name: getName(metadata.name),
            index: newIndex,
          };

          newIndex += 1;
          return result;
        }, { ...state });
      }

      return _.reduce(action.payload.headers, (result, header) => {
        result[concatKey(header)] = getMetadataBody(header, newIndex);
        newIndex += 1;
        return result;
      }, { ...state });

    case types.SET_METADATA_TYPE:
      if (action.payload.type === 'Skip') {
        const originalIndex = state[action.payload.key].index;

        const determineIndex = (metadata) => {
          if (metadata.index === originalIndex) {
            return newIndex - 1;
          }

          return metadata.index > originalIndex ? metadata.index - 1 : metadata.index;
        };

        return _.reduce(state, (result, metadata) => {
          result[metadata.key] = {
            ...metadata,
            type: action.payload.key === metadata.key ? action.payload.type : metadata.type,
            index: determineIndex(metadata),
          };

          return result;
        }, {});
      }

      return {
        ...state,
        [action.payload.key]: {
          ...state[action.payload.key],
          type: action.payload.type,
        },
      };

    case types.SET_METADATA_FORMAT:
      return {
        ...state,
        [action.payload.key]: {
          ...state[action.payload.key],
          format: action.payload.format,
        },
      };

    case types.SET_METADATA_FIELD_TYPE:
      return {
        ...state,
        [action.payload.key]: {
          ...state[action.payload.key],
          fieldType: action.payload.fieldType,
        },
      };

    case types.FETCH_MAPPING_SUCCESS:
      return _.reduce(action.payload.data, (result, value) => {
        if (state[value.header]) {
          result[value.header] = {
            ...state[value.header],
            name: value.mapping,
            mapped: true,
          };
        }

        return result;
      }, { ...state });

    case types.SET_TARGET_VALUE:
      return {
        ...state,
        [action.payload.key]: {
          ...state[action.payload.key],
          name: action.payload.name,
          mapped: true,
        },
      };

    case types.CREATE_NEW_METADATA:
      return {
        ...state,
        [concatKey(action.payload.name)]: {
          ...getMetadataBody(action.payload.name),
          custom: true,
          value: action.payload.columns,
          separator: action.payload.separator,
          sync: action.payload.sync,
        },
      };

    case types.DELETE_MAPPING_ITEM:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          name: resetName(state[action.payload].source, action.payload),
          mapped: false,
        },
      };

    case types.DELETE_METADATA_ITEM:
      return _.omit(state, action.payload);

    case types.CLEAR_MAPPING:
      return _.reduce(state, (result, column) => {
        if (column.mapped) {
          result[column.key] = {
            ...column,
            name: resetName(column.source, column.key, result),
            mapped: false,
          };
        }

        return result;
      }, { ...state });

    case types.UPDATE_METADATA_ORDER:
      return {
        ...state,
        ..._.mapKeys(action.payload, 'key'),
      };

    case types.CREATE_VIRTUAL_FILE_START:
      return initialState;

    case types.RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default MetadataReducer;
